import React, { useState } from 'react';
import { GridColumnMenuFilter } from '@progress/kendo-react-grid';
import { SpheraTooltip } from "@sphera-cloud/component-ui-reactjs";
import { Grid, GridColumn as Column, GridColumnMenuWrapper } from "@progress/kendo-react-grid";
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { LoadingPanel } from '../LoadingPanel';
import { TextCell } from './Cell/TextCell';
import { CustomColumnMenu } from "../CustomColumnMenu";
import { ColumnSelectButton } from "../ColumnSelectButton";
import { ColumnManager } from "../../services/columnManager";
import CustomerPortalGridColumns from "../../Data/CustomerPortalGridColumns.json";
import dateFormats from "../../Data/dateFormats.json";

export function CustomerPortalGrid(props) {
    const [exportobj, setexportobj] = useState({});

    const { columnResize, columnReorder, onColumnsSubmit, defaultSettings } = ColumnManager(CustomerPortalGridColumns, "customerPortalGridSettings");
    const [stateColumns, setStateColumns] = React.useState(defaultSettings);

    let dateFormat = "{0:dd/MM/yyyy}";
    let dateFormatFilter = "dd/MM/yyyy";
    if (props.dateFormatId != null) {
        let format = dateFormats.find(x => x.value === props.dateFormatId);
        if (format != null) {
            dateFormat = "{0:" + format.text + "}";
            dateFormatFilter = format.text;
        }
    }

    const exportFunction = () => { exportobj.save(); };
    const handleColumnSubmit = (columns) => {
        let newcolumns = onColumnsSubmit(columns);
        setStateColumns(newcolumns);
    }

    React.useEffect(() => {
        if (props.downloadGrid) {
            exportFunction();
            props.setdownloadGrid(false);
        }
    }, [props.downloadGrid]);

    return (
        <div style={{ height: 'calc(100vh - 260px)', minHeight: '300px' }}>
            <ColumnSelectButton open={props.showColumnSelect} setopen={props.setshowColumnSelect} onColumnsSubmit={handleColumnSubmit} originalColumns={CustomerPortalGridColumns} columns={stateColumns} setStateColumns={setStateColumns} localizations={props.localizations} />
            <ExcelExport data={props.customerPortals} ref={exporter => setexportobj(exporter)}>
                {stateColumns.map(
                    (column, idx) =>
                        column.show && !column.ExcludeFromExport && (
                            <ExcelExportColumn
                                key={idx}
                                field={column.field}
                                title={props.localizations[column.title]}
                            />
                        )
                )}
            </ExcelExport>
            <Grid
                className="sphera-grid"
                style={{
                    height: '100%',
                    width: '100%'
                }}
                data={props.dataResult}
                {...props.dataState}
                onDataStateChange={props.dataStateChange}
                sortable={true}
                reorderable={true}
                resizable={true}
                onColumnReorder={columnReorder}
                onColumnResize={columnResize}
                scrollable="scrollable"
                pageable={{
                    buttonCount: 4,
                    pageSizes: [25, 50, 100]
                }}
            >
                {stateColumns.map(
                    (column, idx) =>
                        column.show && (
                            <Column
                                key={idx}
                                cell={(props2) =>
                                    <TextCell field={column.field}
                                        isLink={column.isLink}
                                        isMenu={column.isMenu}
                                        searchedPhrase=""
                                        linkClick={column.isMenu ? props.CustomerPortalMenuClick : props.handleOpenSite}
                                        clickId={props2.dataItem.id}
                                        DisplayValue={column.adjustTimezone ? props2.dataItem[column.field + "Display"] : props2.dataItem[column.field]}
                                        customer={props.customer}
                                        isDate={column.isDate}
                                        adjustTimezone={column.adjustTimezone}
                                        isBool={column.isBool}
                                        expiredLocalization={props.expiredLocalization}
                                        noExpiratonLocalization={props.noExpiratonLocalization}
                                        tokenExpirationWarning={props.tokenExpirationWarning}
                                    />
                                }
                                field={column.field}
                                title={props.localizations[column.title]}
                                filter={column.filter}
                                format={dateFormat}
                                width={column.noFilterOrSort ? 50 : column.width}
                                minResizableWidth={100}
                                headerClassName={GridColumnMenuFilter.active(column.field, props.dataState.filter) ? 'active' : ''}
                                headerCell={(props2) => {
                                    if (column.isMenu)
                                        return ("");
                                    else
                                        return (
                                            <span className="k-cell-inner">
                                                <span className="k-link" onClick={props2.onClick} onKeyDown={(e) => { if (e.code === "Enter") props2.onClick(); }}>
                                                    <SpheraTooltip anchor="target" position="top" title={props.localizations[column.title]} >
                                                        <span className="k-column-title">{props.localizations[column.title]}</span>
                                                    </SpheraTooltip>
                                                    {props2.children}
                                                </span>
                                                <GridColumnMenuWrapper
                                                    {...props2.columnMenuWrapperProps}
                                                ></GridColumnMenuWrapper>
                                            </span>
                                        );
                                }}
                                columnMenu={(props2) => (
                                    <CustomColumnMenu {...props2} data={props.customerPortals} checkboxFilter={column.checkboxFilter} columns={CustomerPortalGridColumns} useDateFilter={column.field === "timestampCreate"} dateFormatFilter={dateFormatFilter} />
                                )}
                            />
                        )
                )}
            </Grid>
            {props.pending && <LoadingPanel localizations={props.localizations} />}
        </div>
    );
}